import BackOrderedItemsState from "@galarson/Store/BackOrderedItems/BackOrderedItemsState";
import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiParameter,
    doesNotHaveExpand,
    get,
    HasPagingParameters,
    patch,
    post,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";
import {
    OrderCollectionModel,
    OrderModel,
    OrderStatusMappingCollectionModel,
    RmaModel,
} from "@insite/client-framework/Types/ApiModels";

export interface GetOrdersApiParameter extends ApiParameter {
    fromDate: string;
    itemnumber: string;
    ordernumber: string;
    ponumber: string;
    sort: string;
    toDate: string;
}

export interface GetOrderApiParameter extends ApiParameter {
    orderNumber: string;
    expand?: ("orderLines" | "shipments" | "vmidetails")[];
    additionalExpands?: string[];
    sTEmail?: string;
    sTPostalCode?: string;
}

const ordersUrl = "/api/v1/backordereditems";

export async function getOrders(parameter: GetOrdersApiParameter): Promise<BackOrderedItemsState> {
    // can't send empty status array to API
   
    delete (parameter as any).onComplete;
    const newObject = {} as { [key: string]: string };
    
    if (parameter.sort !== "") {
        newObject.sort = parameter.sort;
    }
    if (parameter.fromDate !== "") {
        newObject.fromDate = parameter.fromDate;
    }
    if (parameter.itemnumber !== "") {
        newObject.itemnumber = parameter.itemnumber;
    }
    if (parameter.ordernumber !== "") {
        newObject.ordernumber = parameter.ordernumber;
    }
    if (parameter.ponumber !== "") {
        newObject.ponumber = parameter.ponumber;
    }
    if (parameter.toDate !== "") {
        newObject.toDate = parameter.toDate;
    }

    const orders = await get<BackOrderedItemsState>(ordersUrl, newObject);
    return orders;
}
